// @ts-nocheck
import React, { useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createPromotion } from "../../../features/promotion";
import DashboardNavbar from "../../../components/navbars/dashboardNavbar";
import { Grid } from "@mui/material";
import { FormControl,  MenuItem, Select } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
const AddPromotion = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [language, setLanguage] = useState("en");

  const [formData, setFormData] = useState({
    title: "",
    sub_title: "",
    link: "",
    button_text: "",
    photo: null,
    is_home: false,
    is_special_for_you: false,
    start_date: "",
    end_date: "",
  });

  const [imagePreview, setImagePreview] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleImageChange = (e) => {
    if (e.target.files) {
      setFormData((prev) => ({
        ...prev,
        photo: e.target.files[0],
      }));
      setImagePreview(URL.createObjectURL(e.target.files[0]));
    }
  };

  const handleSubmit = () => {
    const formDataFinal = new FormData();

    formDataFinal.append("language", language);
    formDataFinal.append("folder_name", "Promotion");
    Object.entries(formData).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        formDataFinal.append(key, value);
      }
    });

    dispatch(createPromotion(formDataFinal))
      .then((resultAction) => {
        if (createPromotion.rejected.match(resultAction)) {
          // This means it was a rejection, handle error
          // toast.error("An error occurred while creating the Promotion.");
          console.error(resultAction.payload || resultAction.error);
        } else {
          navigate("/promotion");
          toast.success("Promotion created successfully!");
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("An error occurred while creating the Promotion.");
      });
  };

  return (
    <SoftBox className="language-box">
      <DashboardNavbar />

      <SoftBox>
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
            Add Promotion
          </SoftTypography>
        </SoftBox>

        <SoftBox component="form" role="form">
          <SoftBox mb={2}>
            <FormControl fullWidth size="small">
              <SoftTypography
                htmlFor="language"
                style={{
                  fontSize: "15px ",
                  fontWeight: "500",
                  lineHeight: "normal",
                  marginBottom: "10px",
                }}
              >
                Language
              </SoftTypography>
              <Select
                id="language"
                name="language"
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                IconComponent={KeyboardArrowDownIcon}
                    fullWidth
                    size="small"
                    sx={{
                      padding: "0px 8px !important",
                      height: "40px !important",
                      display: "block !important",
                      ".MuiSelect-select": {
                        padding: "0px 8px !important",
                        height: "40px !important",
                      },
                      ".MuiSelect-nativeInput": {
                        height: "40px !important",
                      },
                      ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                      ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                    }}
              >
                <MenuItem style={{marginBottom:"5px" }} value="en">English</MenuItem>
                <MenuItem value="ar">Arabic</MenuItem>
              </Select>
            </FormControl>
          </SoftBox>
          <Grid container spacing={2}>
            <Grid item md={6} xs={12}>
              <SoftBox mb={2}>
                <SoftBox mb={1} ml={0.5}>
                  <SoftTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Title
                  </SoftTypography>
                </SoftBox>
                <SoftInput
                  type="text"
                  name="title"
                  placeholder="Enter the Promotion title"
                  value={formData.title}
                  onChange={handleChange}
                />
              </SoftBox>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-around",
              }}
            >
              <SoftBox mb={2} sx={{ display: "flex", alignItems: "center" }}>
                <input
                  name="is_home"
                  id="is_home"
                  type="checkbox"
                  checked={formData.is_home}
                  onChange={handleChange}
                  style={{
                    marginRight: "5px",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                  }}
                />
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  htmlFor="is_home"
                >
                  Is Home
                </SoftTypography>
              </SoftBox>
              <SoftBox mb={2} sx={{ display: "flex", alignItems: "center" }}>
                <input
                  name="is_special_for_you"
                  id="is_special_for_you"
                  type="checkbox"
                  checked={formData.is_special_for_you}
                  onChange={handleChange}
                  style={{
                    marginRight: "5px",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                  }}
                />
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  htmlFor="is_special_for_you"
                >
                  Is Special For You
                </SoftTypography>
              </SoftBox>
            </Grid>
          </Grid>
          {formData.is_special_for_you && (
            <Grid container spacing={2}>
              <Grid item md={6} xs={12}>
                <SoftBox mb={2}>
                  <SoftBox mb={1} ml={0.5}>
                    <SoftTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Start Date and Time
                    </SoftTypography>
                  </SoftBox>
                  <SoftInput
                    type="datetime-local"
                    name="start_date"
                    value={formData.start_date}
                    onChange={handleChange}
                  />
                </SoftBox>
              </Grid>
              <Grid item md={6} xs={12}>
                <SoftBox mb={2}>
                  <SoftBox mb={1} ml={0.5}>
                    <SoftTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      End Date and Time
                    </SoftTypography>
                  </SoftBox>
                  <SoftInput
                    type="datetime-local"
                    name="end_date"
                    value={formData.end_date}
                    onChange={handleChange}
                  />
                </SoftBox>
              </Grid>
            </Grid>
          )}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Sub Title
              </SoftTypography>
            </SoftBox>
            <textarea
              name="sub_title"
              placeholder="Enter the description"
              value={formData.sub_title}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            />
          </SoftBox>
          <Grid container spacing={2}>
            <Grid item md={6} xs={12}>
              {/* Button Text Field */}
              <SoftBox mb={2}>
                <SoftBox mb={1} ml={0.5}>
                  <SoftTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Button Text
                  </SoftTypography>
                </SoftBox>
                <SoftInput
                  type="text"
                  name="button_text"
                  placeholder="Enter the Button Text"
                  value={formData.button_text}
                  onChange={handleChange}
                />
              </SoftBox>
            </Grid>
            <Grid item md={6} xs={12}>
              {/* Link Field */}
              <SoftBox mb={2}>
                <SoftBox mb={1} ml={0.5}>
                  <SoftTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Link
                  </SoftTypography>
                </SoftBox>
                <SoftInput
                  type="text"
                  name="link"
                  placeholder="Enter the Link"
                  value={formData.link}
                  onChange={handleChange}
                />
              </SoftBox>
            </Grid>
          </Grid>

          {/* Photo Upload Field */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Icon
              </SoftTypography>
            </SoftBox>
            <input
              type="file"
              accept="image/*"
              name="photo"
              onChange={handleImageChange}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }}
            />
            {imagePreview && (
              <img
                src={imagePreview}
                alt="Preview"
                style={{ width: "150px", height: "150px", marginTop: "20px" }}
              />
            )}
          </SoftBox>

          {/* Submit Button */}
          <SoftBox mt={4} mb={1}>
            <SoftButton
              variant="gradient"
              color="info"
              fullWidth
              onClick={handleSubmit}
            >
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default AddPromotion;
